"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLEARING_METHOD_TO_SUB_CHECK = exports.PostNotarizationSubCheck = void 0;
const contingency_1 = require("./contingency");
/**
 * The three post-notarization review sub-checks surfaced under the single `postNotarizationReview`
 * condition. Each corresponds to one same-reason OGC row, keyed by its clearingMethod (see
 * {@link CLEARING_METHOD_TO_SUB_CHECK}). Canonical here in aven_types so the backend detail service and
 * the partner dashboard agree on the sub-check identity without re-deriving it from clearingMethod.
 */
var PostNotarizationSubCheck;
(function (PostNotarizationSubCheck) {
    PostNotarizationSubCheck["fraud"] = "fraud";
    PostNotarizationSubCheck["ofac"] = "ofac";
    PostNotarizationSubCheck["cip"] = "cip";
})(PostNotarizationSubCheck || (exports.PostNotarizationSubCheck = PostNotarizationSubCheck = {}));
/**
 * Maps each post-notarization clearingMethod to the sub-check it represents. The `postNotarizationReview`
 * condition is backed by three same-reason OGC rows; this map is how the detail view re-splits them into
 * Fraud / OFAC / CIP sub-checks. Exhaustive over the post-notarization clearing methods.
 */
exports.CLEARING_METHOD_TO_SUB_CHECK = {
    [contingency_1.OriginationContingencyClearingMethod.requiresFraudReviewCleared]: PostNotarizationSubCheck.fraud,
    [contingency_1.OriginationContingencyClearingMethod.requiresOfacReviewCleared]: PostNotarizationSubCheck.ofac,
    [contingency_1.OriginationContingencyClearingMethod.requiresCipReviewCleared]: PostNotarizationSubCheck.cip,
};
